import React, { useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IState from '../../core/models/IState';
import { Redirect } from 'react-router-dom';
import * as actions from '../../core/actions/actions';
import RoutesConstants from '../../shared/components/Routes/routes.constants';

const AuthProvider = (props: any) => {
  //const { token }: any = useSelector((state: IState) => { return state.auth });
  useSelector((state: IState) => { return state.auth });
  const dispatch = useDispatch();

  useEffect(() => {
    let token = localStorage.getItem('token');
    if (token)
      dispatch(actions.updateAuth());
    dispatch(actions.updateLanguage());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {localStorage.getItem('token') != null ? props.children : <Redirect to={RoutesConstants.Login} />}
    </React.Fragment>
  )
}

export default AuthProvider;